module.exports = __webpack_public_path__ + "img/bb-terms.6ee1b5c.png";